import React from 'react'
import './../css/GeneralPages.css'
import PageTitle from '../includes/PageTitle'
import Footer from '../includes/Footer'
export default function RefundPolicy() {
  return (
    <>
    <PageTitle title="Refund Policy - ALMOSTINVISIBLE" />
    <div className="gen-intro px-4">
      <h1 className="unbounded text-fluid">
        Refund Policy
      </h1>
    </div>

    <div className="gen-content container">
      <p>
    <section>
        <h2 className="unbounded">1. Introduction</h2>
        <p>
          Thank you for shopping at ALMOSTINVISIBLE! We are committed to providing high-quality products. However, we understand that sometimes things may not work out. This Refund Policy outlines the conditions under which we can process returns and refunds.
        </p>
      </section>

      <section>
        <h2 className="unbounded">2. Damaged Goods</h2>
        <p>
          If you receive a damaged or defective product, please contact us immediately at <strong><a href="mailto:info@vlmstnvsbl.com ">info@vlmstnvsbl.com </a></strong> with details and photographic evidence of the damage. We will review your case and, if deemed appropriate, offer a replacement or store credit. Please note that we do not accept returns for damaged goods under any circumstances, but we will resolve the issue by providing a replacement or store credit based on our evaluation.
        </p>
      </section>

      <section>
        <h2 className="unbounded">3. No Returns for Change of Mind</h2>
        <p>
          We do not accept returns if you simply change your mind about a product. Once the product is shipped to you, the sale is final. Please ensure that you review your order carefully before confirming your purchase.
        </p>
      </section>

      <section>
        <h2 className="unbounded">4. Used Products</h2>
        <p>
          If a product has been used, even once, it is not eligible for a return or refund. We cannot accept returns for products that have been worn, washed, or used in any way, as we cannot guarantee the quality or resellability of such items.
        </p>
      </section>

      <section>
        <h2 className="unbounded">5. How to Request a Refund or Exchange</h2>
        <p>
          If you believe that your product is eligible for a refund or exchange under our policy, please follow these steps:
        </p>
        <ul>
          <li>Contact us at <strong><a href="mailto:info@vlmstnvsbl.com ">info@vlmstnvsbl.com </a></strong> within 7 days of receiving your order.</li>
          <li>Provide your order number and a description of the issue with the product.</li>
          <li>For damaged items, include photographic evidence of the damage or defect.</li>
        </ul>
        <p>
          We will assess your case and inform you of the next steps. If eligible, a refund will be issued in the original payment method or store credit will be provided.
        </p>
      </section>

      <section>
        <h2 className="unbounded">6. Non-refundable Items</h2>
        <p>
          The following items are non-refundable:
        </p>
        <ul>
          <li>Products that have been used, worn, or washed.</li>
          <li>Items purchased during special sales or promotions, unless otherwise stated.</li>
          <li>Gift cards or store credits.</li>
        </ul>
      </section>

      <section>
        <h2 className="unbounded">7. Shipping Fees</h2>
        <p>
          Shipping fees are non-refundable. If you are entitled to a refund or exchange, the cost of return shipping will be the responsibility of the customer unless the return is due to a defect or error on our part.
        </p>
      </section>

      <section>
        <h2 className="unbounded">8. Processing Time</h2>
        <p>
          Once your return or exchange request has been approved, please allow 7-14 business days for us to process and issue your refund, replacement, or store credit.
        </p>
      </section>
      
    
        <p>Last updated: December 2024</p>
        </p>
    </div>
<Footer />
</>
  )
}
